module.exports = __webpack_public_path__ + "img/gu_keyword_rank.f32c5f08.png";